import { EConductivite } from "./enum/conductivite"

export class ControleConductivite {
    Code: string
    Type: EConductivite
    ValeurMesuree: number
    ValeurCible: number = null
    Temperature: number = null

    get Conforme() {
        if (this.ValeurMesuree === null || this.ValeurMesuree === null)
            return false; 
        const lowerBound = 0.95 * this.ValeurCible;
        const upperBound = 1.05 * this.ValeurCible;
        return this.ValeurMesuree >= lowerBound && this.ValeurMesuree <= upperBound;
    }
    
    toJSON() {
        let ms: any = Object.assign({}, this)
        ms.Conforme = this.Conforme;
        return ms;
    }

    static mapFromJSON(json: any): ControleConductivite {
        const ms = new ControleConductivite();

        ms.Code = json.code;
        ms.Type = json.type;
        ms.ValeurMesuree = json.valeurMesuree;
        ms.ValeurCible = json.valeurCible;
        ms.Temperature = json.temperature;
        // ms.Conforme = json.conforme;

        return ms
    }
}